import Typography from "@mui/material/Typography";
import { differenceInCalendarDays, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";

interface Props {
  scheduledDate?: Date | string | null;
}

export function FollowUpDueIndicator({ scheduledDate }: Props) {
  const { t } = useTranslation();

  if (!scheduledDate) return null;

  const date =
    typeof scheduledDate === "string"
      ? parseISO(scheduledDate)
      : scheduledDate;
  if (Number.isNaN(date.getTime())) return null;

  const days = differenceInCalendarDays(date, new Date());

  if (days < 0) {
    return (
      <Typography variant="caption" color="error.main" fontWeight={600}>
        {t("followUps.overdue", { days: Math.abs(days) })}
      </Typography>
    );
  }

  if (days <= 2) {
    return (
      <Typography variant="caption" color="warning.main" fontWeight={600}>
        {days === 0
          ? t("followUps.dueToday")
          : t("followUps.dueSoon", { days })}
      </Typography>
    );
  }

  return null;
}
